// Email Setup Tour
// Sending identity, domain verification, deliverability and sending services
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_email-marketing); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const emailSetupTour = {
  id: 'email-setup',
  name: 'Email Setup Tour',
  displayName: 'Get Your Email Delivered',
  description: 'Sending identity, domain verification, deliverability and sending services',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_email-marketing',
      popover: {
        title: "📧 Welcome to Email",
        description: `
          Email is only useful if it reaches the inbox. Most of that is decided by setup, not by your copy. Here is what matters.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🪪 Your Sending Identity",
        description: `
          Set a **from name** and a **from address** at your own domain — not a free mailbox. Make sure replies reach a monitored inbox, not a black hole.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔐 Verify Your Domain",
        description: `
          This is the big one. Add the **SPF**, **DKIM**, and **DMARC** records to your domain so receiving servers know you are authorised. Skip this and good email still lands in spam.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🌡️ Warm Up Gradually",
        description: `
          A brand-new sending domain blasting thousands of emails looks exactly like a spammer. Start with small, engaged segments and build volume over days and weeks.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📈 Engagement Is the Signal",
        description: `
          Providers watch opens, replies, and complaints. So: only email people who asked, remove hard bounces and long-term non-openers, and send on a consistent cadence.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🚀 Dedicated Sending Services",
        description: `
          For real volume, connect your own service — **MailGun** or another **SMTP provider**. You get your own reputation, higher limits, and delivery logs you can inspect.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "✍️ Habits That Hurt",
        description: `
          Misleading subject lines, one giant image with no text, link shorteners, and ALL-CAPS urgency all push you toward spam. Write like a person.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Email Is Set Up",
        description: `
          You can now:

✅ Send from a verified domain
✅ Authenticate with SPF, DKIM and DMARC
✅ Warm up and protect engagement
✅ Scale with a dedicated sender

**Next:** verify your domain, then send a test to two different mailbox providers.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
